import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useNavigate } from '@/routing'
import { isGpsOnly } from '@/features/domain/user'
import { useResidentModalsApi } from '@/components/modals/ResidentModals'

export function useActions() {
  const navigate = useNavigate<uui.routing.MainSections>(true)
  const {
    supportTicket: { show: handleSupportTicket },
  } = useResidentModalsApi()

  const gpsOnly = useSelector(isGpsOnly)

  const onNavigateHome = useCallback(() => {
    navigate(gpsOnly ? 'tracking' : 'routing')
  }, [navigate, gpsOnly])

  const onOpenSupportTicket = useCallback(() => {
    handleSupportTicket()
  }, [handleSupportTicket])

  return {
    onNavigateHome,
    onOpenSupportTicket,
  }
}
